import { useEffect, useRef } from 'react';

// Cloudflare Turnstile (free captcha). Renders nothing until
// REACT_APP_TURNSTILE_SITE_KEY is set at build time, so the booking flow
// works unchanged before the keys are configured.
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export const isCaptchaEnabled = !!siteKey;

const TurnstileWidget = ({ onToken }) => {
    const containerRef = useRef(null);
    const onTokenRef = useRef(onToken);
    onTokenRef.current = onToken;

    useEffect(() => {
        if (!siteKey || !containerRef.current) return undefined;

        let widgetId = null;
        let cancelled = false;

        const renderWidget = () => {
            if (cancelled || !window.turnstile || !containerRef.current) return;
            widgetId = window.turnstile.render(containerRef.current, {
                sitekey: siteKey,
                callback: (token) => onTokenRef.current(token),
                'expired-callback': () => onTokenRef.current(''),
                'error-callback': () => onTokenRef.current(''),
            });
        };

        if (window.turnstile) {
            renderWidget();
        } else {
            let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
            if (!script) {
                script = document.createElement('script');
                script.src = SCRIPT_SRC;
                script.async = true;
                document.head.appendChild(script);
            }
            script.addEventListener('load', renderWidget);
        }

        return () => {
            cancelled = true;
            if (widgetId !== null && window.turnstile) {
                window.turnstile.remove(widgetId);
            }
        };
    }, []);

    if (!siteKey) return null;
    return <div ref={containerRef} className="mb-3" />;
};

export default TurnstileWidget;
